module.exports = "/fast-coin/img/coin/anim/shine_1/shine_1_024.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/fast-coin/img/coin/anim/shine_1/shine_1_024.png
// module id = 2340
// module chunks = 5